class UrlService {
  public static BuildQuery = (body: object): string => {
    let suffix = '?';
    Object.keys(body).forEach((key: string) => {
      if (suffix.length > 1) {
        suffix += '&';
      }
      if (typeof body[key] === 'undefined' || body[key] === null || body[key] === '') {
        // do nothing;
      } else if (
        typeof body[key] === 'boolean' ||
        typeof body[key] === 'string' ||
        typeof body[key] === 'number'
      ) {
        suffix += `${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`;
      } else if (Array.isArray(body[key])) {
        const data = body[key].map(item => encodeURIComponent(item)).join(`&${encodeURIComponent(key)}=`);
        suffix += `${encodeURIComponent(key)}=${data}`;
      } else if (typeof body[key] === 'object') {
        let dateString = '';
        if (body[key] === null || body[key] === undefined || body[key] === '') {
          dateString = '';
        } else {
          dateString = body[key].toISOString();
        }
        suffix += `${encodeURIComponent(key)}=${encodeURIComponent(dateString)}`;
      }
    });
    return suffix.length > 1 ? suffix : '';
  };
}

export { UrlService };
